export default __webpack_public_path__ + "static/media/largepsychicpot.96d91aad.PNG";